var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 27.5C4.22386 27.5 4 27.7239 4 28C4 28.2761 4.22386 28.5 4.5 28.5L27.5 28.5C27.7761 28.5 28 28.2761 28 28C28 27.7239 27.7761 27.5 27.5 27.5L4.5 27.5ZM16 3.00001C16.0118 3.00001 16.0235 3.00029 16.0351 3.00084C16.1188 3.00479 16.1985 3.02279 16.2716 3.05236C16.3339 3.07752 16.393 3.11174 16.4465 3.15504C16.4601 3.16599 16.4732 3.17744 16.4858 3.18935L23.3003 9.53203C23.5666 9.77987 23.5666 10.1817 23.3003 10.4295C23.034 10.6773 22.6023 10.6773 22.336 10.4295L16.6818 5.16675L16.6818 18.8654C16.6818 19.2159 16.3766 19.5 16 19.5C15.6234 19.5 15.3182 19.2159 15.3182 18.8654L15.3182 5.16669L9.6639 10.4295C9.39764 10.6773 8.96593 10.6773 8.69966 10.4295C8.4334 10.1817 8.4334 9.77986 8.69966 9.53203L15.5179 3.18588C15.5881 3.12055 15.6698 3.07243 15.7569 3.04154C15.8159 3.02058 15.8788 3.00703 15.9443 3.0021C15.9627 3.00072 15.9813 3.00001 16 3.00001Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnUpload);
export default __webpack_public_path__ + "static/media/icn-upload.5fa52472.svg";
export { ForwardRef as ReactComponent };